module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><div><label for="recipient-email">'+
((__t=( i18n.tc("Recipients", "E-mail:") ))==null?'':__t)+
'</label> <input id="recipient-email" value="'+
((__t=( email ))==null?'':__t)+
'" type="email" data-input="recipient-email"></div><div class="input"><input id="recipient-email-general-alerts" type="checkbox" data-input="recipient-email-general-alerts" '+
((__t=( generalLevel?'checked':'' ))==null?'':__t)+
'> <label for="recipient-email-general-alerts" class="align-left"> '+
((__t=( i18n.tc("Recipients", "General alerts") ))==null?'':__t)+
'</label></div><div class="input"><input id="recipient-email-emergency-alerts" type="checkbox" data-input="recipient-email-emergency-alerts" '+
((__t=( emergencyLevel?'checked':'' ))==null?'':__t)+
'> <label for="recipient-email-emergency-alerts" class="align-left">'+
((__t=( i18n.tc("Recipients", "Emergency alerts") ))==null?'':__t)+
'</label></div></fieldset><fieldset class="button-wrap"><button data-click="recipient-edit-cancel">'+
((__t=( i18n.tc("NotificationRecipient", "Cancel") ))==null?'':__t)+
'</button> <button type="submit" data-click="recipient-submit" class="primary" disabled="disabled">'+
((__t=( i18n.tc("Recipients", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
